import {Entity} from '../../../core/commons/entity';
import {DynFieldData} from '../data/dyn-field-data';

export abstract class DynField implements Entity {

    id: number;

    private type: string;
    public name: string;
    private label: string;
    private alignment: string;
    private required: boolean;
    private max: number;
    private min: number;
    private pattern: string;
    private text: string;
    private defaultValue: string;
    private order: number;
    private divider: boolean;
    private referenceLabel: string;
/*
    public static createFromObject(object: {type: string}): DynField {
        switch (object.type) {
            case 'boolean':
                return DynBooleanField.createFromObject(object);
            case 'date':
                return DynDateField.createFromObject(object);
            case 'select':
                return DynSelectField.createFromObject(object);
            case 'subform':
                return DynSubformField.createFromObject(object);
            case 'textarea':
                return DynTextAreaField.createFromObject(object);
            case 'text':
                return DynTextField.createFromObject(object);
            case 'time':
                return DynTimeField.createFromObject(object);
        }
    }
    */

    constructor(id: number = null,
                type = 'text',
                name = 'sin_nombre',
                label = 'Sin Nombre',
                alignment = '',
                referenceLabel = '',
                required = true,
                max = 50,
                min = 0,
                pattern = null,
                order = null,
                text = null,
                defaultValue = null,
                divider = false
                )  {

        this.id = id;
        this.type = type;
        this.name = name;
        this.alignment = alignment;
        this.label = label;
        this.referenceLabel = referenceLabel;
        this.required = required;
        this.max = max;
        this.min = min;
        this.pattern = pattern;
        this.order = order
        this.text = text;
        this.defaultValue = defaultValue;
        this.divider = divider;
    }

    getId(): number {
        return this.id;
    }

    setId(id: number) {
        this.id = id;
    }

    getType(): string {
        return this.type;
    }

    setType(value: string) {
        this.type = value;
    }

    getName(): string {
        return this.name;
    }

    setName(name: string) {
        this.name = name;
    }

    getLabel(): string {
        return this.label;
    }

    setLabel(label: string) {
        this.label = label;
    }

    getAlignment(): string {
        return this.alignment;
    }

    setAlignment(alignment: string) {
        this.alignment = alignment;
    }

    getReferenceLabel():string{
    	return this.referenceLabel;
    }
    
    setReferenceLabel(value:string){
    	this.referenceLabel = value;
    }

    getRequired(): boolean {
        return this.required;
    }

    setRequired(value: boolean) {
        this.required = value;
    }

    getDivider(): boolean {
        return this.divider;
    }

    setDivider(value: boolean) {
        this.divider = value;
    }

    getMax(): number {
        return this.max;
    }

    setMax(value: number) {
        this.max = value;
    }

    getMin(): number {
        return this.min;
    }

    setMin(value: number) {
        this.min = value;
    }

    getPattern(): string {
        return this.pattern;
    }

    setPattern(value: string) {
        this.pattern = value;
    }

    getText(): string {
        return this.text ? this.text.replace(/<br>/g, '\n') : this.text;
    }

    setText(value: string) {
        this.text = value;
    }

    getDefaultValue(): string {
        return this.defaultValue ? this.defaultValue.replace(/<br>/g, '\n') : this.defaultValue;
    }

    setDefaultValue(value: string) {
        this.defaultValue = value;
    }

    getOrder(): number {
        return this.order;
    }

    setOrder(value: number) {
        this.order = value;
    }

    public getTextWithBrReplaced(): string {
        return this.getText().replace(/<br>/g, "\n")
    }

    public getValue(data: DynFieldData): any {
        return data.getValue();
    }

    public setValue(data: DynFieldData, value: any) {
        data.setValue(value);
    }

    public getValueAsString(data: DynFieldData): string {
        return this.getValue(data);
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/dyn-field.ts